import React from "react";
import AnimatedBackground from "./AnimatedBackground";

const Background = () => {
  return (
    <div className="absolute inset-0 z-0 ">
      <video
        autoPlay
        loop
        muted
        playsInline
        preload="auto"
        className="w-full h-full object-cover overflow-hidden pointer-events-none"
        onContextMenu={(e) => e.preventDefault()} // Prevents right-click context menu
        disablePictureInPicture
        disableRemotePlayback
      >
        <source src="/bg.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      {/* <AnimatedBackground /> */}
    </div>
    // <div
    //   className="absolute inset-0 z-0 bg-repeat"
    //   style={{
    //     backgroundImage: `url(./pattern.png)`,
    //     backgroundSize: "200px 200px", // Adjust size as needed
    //   }}
    // />
  );
};

export default Background;
